import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';
import { RiFileCopyLine } from '@remixicon/react';
import { copyToClipboard } from '@/utils/helpers';

interface FingerprintChipProps {
  fingerprint: string;
  maxLength?: number;
  toastMessage?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function FingerprintChip({
  fingerprint,
  maxLength = 12,
  toastMessage = 'Fingerprint copied!',
  size = 'sm'
}: FingerprintChipProps) {
  const { t } = useTranslation();
  // Return null if fingerprint is empty or null
  if (!fingerprint || fingerprint.trim() === '') {
    return null;
  }

  const truncateText = (text: string, maxLen: number) => {
    if (text.length <= maxLen) return text;
    return text.substring(0, maxLen) + '...';
  };

  const handleCopy = () => {
    copyToClipboard(fingerprint, toastMessage);
  };

  return (
    <Chip
      size={size}
      variant="flat"
      color="default"
      className="cursor-pointer font-mono text-xs hover:bg-gray-100 dark:hover:bg-gray-800"
      startContent={<RiFileCopyLine className="h-3 w-3" />}
      onClick={handleCopy}
    >
      {truncateText(fingerprint, maxLength)}
    </Chip>
  );
}
